import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconArrow = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M1 5.79825H16.8749M16.8749 5.79825L12.0766 1M16.8749 5.79825L12.0766 10.5965" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default IconArrow
